import React, { Component } from "react";
import PropTypes from "prop-types";
import SendMessage from "./send_message";
import ReceivedMessage from "./received_message";

class MessageList extends Component {
  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  }

  render() {
    const { messages } = this.props;

    return (
      <div className='inbox-messages-history' ref={node => this.node = node}>
        {messages.map(message => {
          if (message.is_my_message == true) {
            return (
              <SendMessage key={message.id} message={message} />
            );
          } else {
            return (
              <ReceivedMessage key={message.id} message={message} />
            );
          }
        })}
        <div style={{ float:"left", clear: "both" }} ref={el => this.messagesEnd = el} />
      </div>
    );
  }
}

MessageList.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object)
};

MessageList.defaultProps = {
  messages: []
};

export default MessageList;
